import { methodGet, methodPost, methodPost2 } from '@/api'
import store from '@/store'

export const addrbook = {
  data() {
    const checkGroupName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('device.validator.group.name_null')))
      }

      if (value.length > 10) {
        return callback(new Error(this.$t('device.validator.group.name_length')))
      }

      callback()
    }
    const checkDeviceNumber = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('device.validator.number_null')))
      }

      const regMzNumber = /^(6|8)\d{9}$/

      if (!regMzNumber.test(value)) {
        return callback(new Error(this.$t('device.validator.number_rule')))
      }

      callback()
    }
    const checkUserNumber = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('user.validator.number_null')))
      }

      if (value.match('^1\\d{10}$')) {
        this.addUserForm.number = `386${value}`
      } else {
        if (!value.match('^[1-8]\\d{6,16}$')) {
          return callback(new Error(this.$t('user.validator.number_rule')))
        }
      }

      callback()
    }
    const checkDeviceName = (rule, value, callback) => {
    //   if (!value) {
    //     return callback(new Error(this.$t('device.validator.name_null')))
    //   }
      callback()
    }
    return {
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      dataCount: 0,
      pageSize: 10,
      pageIndex: 1,
      brandDataCount: 0,
      brandPageSize: 10,
      brandPageIndex: 1,
      listBook: [],
      listBrand: [],
      tableData: [],
      brandTableData: [],
      filteredTreeData: [],
      addGroupDialogVisible: false,
      delGroupDialogVisible: false,
      editGroupDialogVisible: false,
      addDeviceDialogVisible: false,
      addGroupManagerDialogVisible: false,
      addUserDialogVisible: false,
      delDeviceDialogVisible: false,
      startNowDialogVisible: false,
      stopNowDialogVisible: false,
      adjustDeviceGroupDialogVisible: false,
      editDeviceNameDialogVisible: false,
      noChildrenDialogVisible: false,
      operateNodeId: 0,
      defaultExpandedKeys: [],
      defaultCheckedKey: [],
      addGroupForm: {
        name: '',
        parentId: 0,
        maxId: 0
      },
      editGroupForm: {
        name: ''
      },
      addDeviceForm: {
        name: '',
        number: '',
        groupName: '',
        groupId: 0
      },
      addGroupManagerForm: {
        abled: false,
        name: '',
        pwd: '',
        rePwd: '',
        groupName: '',
        groupId: 0
      },
      addUserForm: {
        number: '',
        groupName: '',
        groupId: 0
      },
      editDeviceForm: {
        name: '',
        number: '',
        id: 0
      },
      addGroupRules: {
        name: [
          {
            validator: checkGroupName,
            trigger: 'blur'
          }
        ]
      },
      addDeviceRules: {
        number: [
          {
            validator: checkDeviceNumber,
            trigger: 'blur'
          }
        ]
      },
      addUserRules: {
        number: [
          {
            validator: checkUserNumber,
            trigger: 'blur'
          }
        ]
      },
      editDeviceRules: {
        name: [
          {
            validator: checkDeviceName,
            trigger: 'blur'
          }
        ]
      },
      loading: false,
      multipleSelection: [],
      opearteDeviceIds: [],
      adjustGroupId: 0,
      selectedNode: '',
      searchKeyword: '',
      gtype: 1,
      visible: false,
      adjustButtonClass: 'adjust-button opearte-font opearte-border',
      addDeviceButtonClass: 'add-device-button',
      searchInputplaceholder: 'opearte-font'
    }
  },
  created() {
    //新增信息推送分组类型为3 
    this.gtype = 3 
    this.loadGroupTree(this.gtype)
  },
  beforeRouteLeave(to, from, next) {

    next()
  },
  watch: {
    // 监听 treeData 的变化
    treeData: {
      handler(newVal) {
        // 过滤掉根节点，只保留子节点
        if (newVal[0] != undefined) {
          console.log('groupID===================='+store.state.groupID)
          this.filteredTreeData = newVal[0].children
          if (store.state.groupID != 0) {
            this.filteredTreeData = newVal[0].children.filter(function (item) {
              return item.id == store.state.groupID;
            });
          }
        }
      },
      immediate: true // 立即触发一次，以处理初始数据
    },
    // 监听语言变化
    '$i18n.locale': {
      handler(newVal, oldVal) {
        if (newVal === 'en') {
          this.adjustButtonClass = 'adjust-button-en opearte-font opearte-border'
          this.addDeviceButtonClass = 'add-device-button-en'
          this.searchInputplaceholder = 'opearte-font-en'
        }
      },
      immediate: true,
    },
  },
  computed: {
    isButtonDisabled() {
      // 如果没有选中的行，按钮应该被禁用  
      return this.multipleSelection.length === 0;
    }
  },
  methods: {
    // handleVisibleChange(data) {
    // //   // eslint-disable-next-line no-console
    // //   console.log(data);
    //   if(data.show) {
    //     this.$set(data, 'show', false)
    //   }else{
    //     this.$set(data, 'show', true)
    //   }
    // },
    formatDevModel(status) {
      let fomSt = ''
      if (status == 'online') {
        fomSt = '空闲'
      } else if (status == 'playing') {
        fomSt = '推送中'
      } else if (status == 'offline') {
        fomSt = '离线'
      }
      return fomSt
    },
    formatDateTime(timestamp) {
      if (timestamp == undefined || timestamp == null || timestamp == '') {
        return ''
      }
      const date = new Date(timestamp) // 将时间戳转换为毫秒  
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月份从0开始，所以要加1  
      const day = ('0' + date.getDate()).slice(-2);
      const hours = ('0' + date.getHours()).slice(-2);
      const minutes = ('0' + date.getMinutes()).slice(-2);
      const seconds = ('0' + date.getSeconds()).slice(-2); // 添加秒数  
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    handleCommand(data) {
      // eslint-disable-next-line no-console
      console.log(data)
    },
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.computePage()
    },
    handleCurrentChange(newPage) {
      this.pageIndex = newPage
      this.computePage()
    },
    handleBrandSizeChange(newSize) {
      this.brandPageIndex = newSize
      this.computeBrandPage()
    },
    handleBrandCurrentChange(newPage) {
      this.brandPageIndex = newPage
      this.computeBrandPage()
    },
    handleNodeClick(node) {
      this.selectedNode = node
      this.listMemberUnderGroup(node.id)
    },
    listMemberUnderGroup(id) {
      const params = {
        params: {
          groupId: id
        }
      }
      methodGet('/api/infoPush/get', params).then((data) => {
        this.listBook = data.data
        this.computePage()
      })
    },
    computePage() {
      if (this.listBook == null) {
        this.dataCount = 0
        this.tableData = []
      } else {
        this.dataCount = this.listBook.length
        let start = (this.pageIndex - 1) * this.pageSize
        start = start > this.dataCount ? this.dataCount : start
        let end = Number(this.pageSize) + start
        end = end > this.dataCount ? this.dataCount : end
        this.tableData = this.listBook.slice(start, end)
      }
    },
    computeBrandPage() {
      if (this.listBrand == null) {
        this.brandDataCount = 0
        this.brandTableData = []
      } else {
        this.brandDataCount = this.listBrand.length
        let start = (this.brandPageIndex - 1) * this.brandPageSize
        start = start > this.brandDataCount ? this.brandDataCount : start
        let end = Number(this.brandPageSize) + start
        end = end > this.brandDataCount ? this.brandDataCount : end
        this.brandTableData = this.listBrand.slice(start, end)
      }
    },
    handleExpandCollapse(node) {
      // 处理展开和折叠事件
      this.$refs.tree.toggleNode(node)
    },
    mouseenter(data) {
      this.$set(data, 'show', true)
    },
    mouseleave(data) {
      this.$set(data, 'show', false)
    },
    loadGroupTree(gtype, chooseId) {
      methodGet(`api/group/loadInfoPushGroupTree/${gtype}`).then((data) => {
        
        console.info("查询推送分组数据："+data.data)
        if (data.data == null) {
            //初始化一个类型为3的根分组
            const params = {
                gtype: gtype,
                name: ''
            }
            methodPost('api/group/addGroupFirst', params).then((data) => {
                if (data.status) {
                    this.loadGroupTree(this.gtype)
                    //this.$message({ message: this.$t('opearteSuccess'), type: 'success' })
                } else {
                    this.$message.error(this.$t('serverError'))
                }
            })
        } else {
            let arr = []
            arr[0] = data.data
            this.treeData = arr
            this.defaultExpandedKeys.push(data.data.id)
            if (chooseId == undefined) {
    
              this.$nextTick(() => {
                if (data.data.children[0] != undefined) {
                  this.defaultCheckedKey = data.data.children[0].id
                  this.$refs.tree.setCurrentKey(this.defaultCheckedKey)
                } else {
                  this.defaultCheckedKey = data.data.id
                  this.$refs.tree.setCurrentKey(this.defaultCheckedKey)
                }
              })
    
              if (this.selectedNode != '') {
                this.listMemberUnderGroup(this.selectedNode.id)
              } else {
                if (data.data.children[0] != undefined) {
                  this.listMemberUnderGroup(data.data.children[0].id)
                } else if (this.gtype == 2) {
                  this.listMemberUnderGroup(data.data.id)
                }
              }
    
            } else {
              this.$nextTick(() => {
                this.$refs.tree.setCurrentKey(chooseId)
              })
              this.listMemberUnderGroup(chooseId)
            }
        }
        
      })
    },
    
    closeAddGroupDialog() {
      this.addGroupDialogVisible = false
      this.addGroupForm = {}
      this.$refs.addGroupForm.resetFields()
    },
    closeEditGroupDialog() {
      this.editGroupDialogVisible = false
      this.editGroupForm.name = {}
      this.$refs.editGroupForm.resetFields()
    },
    openAddGroupDialog(data) {
      const array = data.children
      let maxId
      // eslint-disable-next-line no-undefined
      if (!array || array.length == 0) {
        maxId = data.id
      } else {
        maxId = array[array.length - 1].id
      }
      this.addGroupForm.maxId = maxId
      this.addGroupForm.parentId = data.id
      this.addGroupDialogVisible = true
    },
    openDelGroupDialog(data) {
      this.operateNodeId = data.id
      this.delGroupDialogVisible = true
    },
    openEditGroupDialog(data) {
      this.operateNodeId = data.id
      this.editGroupForm.name = data.name
      this.editGroupDialogVisible = true
    },
    addGroup() {
      this.$refs['addGroupForm'].validate((valid) => {
        if (valid) {
          this.addGroupDialogVisible = false
          let name
          if (this.addGroupForm.name == '' || this.addGroupForm.name == undefined) {
            name = this.addGroupForm.name
          } else {
            name = this.addGroupForm.name.replace(/\s/g, '')
          }
          const params = {
            parentId: this.addGroupForm.parentId,
            name: name,
            maxId: this.addGroupForm.maxId
          }
          methodPost('api/group/addGroup', params).then((data) => {
            if (data.status) {
              this.loadGroupTree(this.gtype)
              this.$message({ message: this.$t('opearteSuccess'), type: 'success' })
            } else {
              this.$message.error(this.$t('serverError'))
            }
          })
        } else {
          return false
        }
      })
    },
    delGroup() {
      this.delGroupDialogVisible = false
      const params = {
        id: this.operateNodeId,
        isInfoPush: 1
      }
      methodPost('api/group/deleteGroup', params).then((data) => {
        if (data.status) {
          this.loadGroupTree(this.gtype)
          this.$message({ message: this.$t('opearteSuccess'), type: 'success' })
        } else {
          let error = this.$t('serverError')
          if (data.msg == '要删除的分组不存在') {
            error = this.$t('addrbook.return.delDevice.tips_1')
          }
          if (data.msg == '要删除的分组下有子分组，不能删除') {
            error = this.$t('addrbook.return.delDevice.tips_2')
          }
          if (data.msg == '要删除的分组下有人员，不能删除') {
            error = this.$t('addrbook.return.delDevice.tips_3')
          }
          this.$message.error(error);
        }
      })
    },
    editGroup() {
      this.$refs['editGroupForm'].validate((valid) => {
        if (valid) {
          this.editGroupDialogVisible = false
          let name
          if (this.editGroupForm.name == '' || this.editGroupForm.name == undefined) {
            name = this.editGroupForm.name
          } else {
            name = this.editGroupForm.name.replace(/\s/g, '')
          }
          const params = {
            id: this.operateNodeId,
            name: name
          }
          methodPost('api/group/updateGroup', params).then((data) => {
            if (data.status) {
              this.loadGroupTree(this.gtype, this.operateNodeId)
              this.$message({ message: this.$t('opearteSuccess'), type: 'success' })
            } else {
              this.$message.error(this.$t('serverError'));
            }
          })
        } else {
          return false
        }
      })
    },
    allowDrop(draggingNode, dropNode, type) {
      if (draggingNode.data.parentId == 0) {
        return false
      }

      if (type === 'inner') {
        return false
      }

      if (dropNode.data.parentId != draggingNode.data.parentId) {
        return false
      }

      return true
    },
    handleDrop(draggingNode, dropNode, dropType, ev) {
      const params = {
        id: draggingNode.data.id,
        targetId: dropNode.data.id
      }
      methodPost('api/group/adjustOrderGroup', params).then((data) => {
        if (data.status) {
          this.loadGroupTree(this.gtype, draggingNode.data.id)
          this.$message({ message: this.$t('opearteSuccess'), type: 'success' })
        } else {
          this.$message.error(this.$t('serverError'));
        }
      })
    },
    openInfoPushSetPage() {
      if (this.selectedNode.useId == null || this.selectedNode.useId == undefined) {

        return
      }
      //后来发现这个方法可行
      let id = this.selectedNode.useId.replace(/\+/g, "%2B");

      const path = 'http://zx.mysher.com/info-push/openSettingProgram?groupId='+id
      // console.info("path="+path)
      // const path = 'http://zx.mysher.com'
      window.open(path, '_blank'); // 在新窗口或标签页中打开URL  
    },
    openAddDeviceDialog() {
      if (this.treeData[0].children.length == 0) {
        this.noChildrenDialogVisible = true
        return
      }
      this.addDeviceDialogVisible = true
      if (this.selectedNode != '') {
        this.addDeviceForm.groupName = this.selectedNode.name
        this.addDeviceForm.groupId = this.selectedNode.id
        console.info("useId="+this.selectedNode.useId)
      } else {
        const defaultNode = this.$refs.tree.getNode(this.defaultCheckedKey)
        this.addDeviceForm.groupName = defaultNode.data.name
        this.addDeviceForm.groupId = defaultNode.data.id
        console.info("defaultNode.data.useId="+defaultNode.data.useId)
      }
    },
    openGroupManagerDialog() {
      if (this.treeData[0].children.length == 0) {
        this.noChildrenDialogVisible = true
        return
      }
      this.addGroupManagerDialogVisible = true
      if (this.selectedNode != '') {
        this.addGroupManagerForm.groupName = this.selectedNode.name
        this.addGroupManagerForm.groupId = this.selectedNode.id
        console.info("openGroupManagerDialog---this.selectedNode.id="+this.selectedNode.id)
      } else {
        const defaultNode = this.$refs.tree.getNode(this.defaultCheckedKey)
        this.addGroupManagerForm.groupName = defaultNode.data.name
        this.addGroupManagerForm.groupId = defaultNode.data.id
        console.info("openGroupManagerDialog---defaultNode.data.useId="+defaultNode.data.id)
      }

      const params = {
        groupID: this.addGroupManagerForm.groupId
      }
      methodPost('api/account/getGroupMng', params).then((data) => {
          if (data.status) {
            if (data.data != null || data.data != undefined) {
              this.addGroupManagerForm.name = data.data.userName
              this.addGroupManagerForm.abled = true
            } else {
              this.addGroupManagerForm.abled = false
            }
          }
      })
    },
    openAddUserDialog() {
      this.addUserDialogVisible = true
      // eslint-disable-next-line no-negated-condition
      if (this.selectedNode != '') {
        this.addUserForm.groupName = this.selectedNode.name
        this.addUserForm.groupId = this.selectedNode.id
      } else {
        const defaultNode = this.$refs.tree.getNode(this.defaultCheckedKey)
        this.addUserForm.groupName = defaultNode.data.name
        this.addUserForm.groupId = defaultNode.data.id
      }
    },
    closeAddDeviceDialog() {
      this.addDeviceDialogVisible = false
      this.addDeviceForm = {}
      this.$refs.addDeviceForm.resetFields()
    },
    closeGroupManagerDialog() {
      this.addGroupManagerDialogVisible = false
      this.addGroupManagerForm = {}
      this.$refs.addGroupManagerForm.resetFields()
    },
    closeAddUserDialog() {
      this.addUserDialogVisible = false
      this.addUserForm = {}
      this.$refs.addUserForm.resetFields()
    },
    openDelDeviceDialog() {
      this.delDeviceDialogVisible = true
      this.opearteDeviceIds = this.multipleSelection.map((item) => item.id)
    },
    openStartNowDialog() {
      this.startNowDialogVisible = true
      this.opearteDeviceIds = this.multipleSelection.map((item) => item.id)
    },
    openStopNowDialog() {
      this.stopNowDialogVisible = true
      this.opearteDeviceIds = this.multipleSelection.map((item) => item.id)
    },
    openAdjustDeviceGroupDialog() {
      this.adjustDeviceGroupDialogVisible = true
      this.opearteDeviceIds = this.multipleSelection.map((item) => item.id)
    },
    addDeviceTreeNodeCilck(data) {
      this.addDeviceForm.groupId = data.id
      this.addDeviceForm.groupName = data.name
      this.$refs.selectUpResId.blur()
    },
    addGroupManagerTreeNodeCilck(data) {
      this.addGroupManagerForm.groupId = data.id
      this.addGroupManagerForm.groupName = data.name
      this.$refs.selectUpResId.blur()
    },
    addUserTreeNodeCilck(data) {
      this.addUserForm.groupId = data.id
      this.addUserForm.groupName = data.name
      this.$refs.selectUpResId.blur()
    },
    addGroupManager() {
      let result = true;
      if (this.addGroupManagerForm.name == null || this.addGroupManagerForm.name == "") {

          this.$message.error(this.$t('register.usernameError'));
          result = false;
      }
      if (this.addGroupManagerForm.pwd == null || this.addGroupManagerForm.pwd == "") {

          this.$message.error(this.$t('register.passwordError'));
          result = false;
      }
      if (this.addGroupManagerForm.rePwd == null || this.addGroupManagerForm.rePwd == "") {

          this.$message.error(this.$t('register.passwordError'));
          result = false;
      }
      if (this.addGroupManagerForm.pwd != this.addGroupManagerForm.rePwd) {

          this.$message.error(this.$t('register.rePasswordError'));
          result = false;
      }

      if (result) {
        if (this.addGroupManagerForm.abled == true) {
          const params = {
            groupID: this.addGroupManagerForm.groupId,
            pwd: this.addGroupManagerForm.pwd
          }
          methodPost('api/account/updateUserPwd', params).then((data) => {
              if (data.status) {
                this.$message.success(this.$t('opearteSuccess'));
              } else {
                  this.$message.error(this.$t('serverError'));
              }
          })
        } else {
          const params = {
            username: this.addGroupManagerForm.name,
            email: ''
          }
          methodPost('api/account/unregistered/user', params).then((data) => {
              if (data.status) {
                const params = {
                  userName: this.addGroupManagerForm.name,
                  userPassword: this.addGroupManagerForm.pwd,
                  orgName: this.addGroupManagerForm.groupId
                }
                methodPost2('api/account/registerGroupMng/', params).then((data) => {
                    if (data.status) {
                      this.$message.success(this.$t('opearteSuccess'));
                    } else {
                        this.$message.error(this.$t('serverError'));
                    }
                })
              } else {
                  if (data.msg == '用户名已存在，请修改您的用户名') {
                      this.$message.error(this.$t('register.usernameError_exist'));
                      return;
                  }
                  this.$message.error(this.$t('serverError'));
              }
          })
        }
        this.addGroupManagerDialogVisible = false
      }

    },
    addDevice() {
      this.$refs['addDeviceForm'].validate((valid) => {
        if (valid) {
          this.addDeviceDialogVisible = false
          
          const params = {
            mzNumber: this.addDeviceForm.number,
            groupId: this.addDeviceForm.groupId,
            devModel: ''
          }
          methodPost2('api/infoPush/insert', params).then((data) => {
            if (data.status) {
              if (this.selectedNode == '') {
                const defaultNode = this.$refs.tree.getNode(this.defaultCheckedKey)
                this.$refs.tree.setCurrentKey(defaultNode.id)
                this.listMemberUnderGroup(defaultNode.data.id)
              } else {
                this.$refs.tree.setCurrentKey(this.selectedNode.id)
                this.listMemberUnderGroup(this.selectedNode.id)
              }
              this.$message({ message: this.$t('opearteSuccess'), type: 'success' })
            } else {
              let error = this.$t('serverError')
              if (data.msg == '已添加，请查看其它分组') {
                error = this.$t('addrbook.return.addDevice.tips_1')
              }
              if (data.msg == '已被其它企业添加') {
                error = this.$t('addrbook.return.addDevice.tips_2')
              }
              if (data.msg == '该号码不存在') {
                error = this.$t('addrbook.return.addDevice.tips_3')
              }
              this.$message.error(error);
            }
          })
        } else {
          return false
        }
      })
    },
    addUser() {
      this.$refs['addUserForm'].validate((valid) => {
        if (valid) {
          this.addUserDialogVisible = false
          const params = {
            mzNumber: this.addUserForm.number,
            groupId: this.addUserForm.groupId,
            devModel: ''
          }
          methodPost2('api/infoPush/insert', params).then((data) => {
            if (data.status) {
              if (this.selectedNode == '') {
                const defaultNode = this.$refs.tree.getNode(this.defaultCheckedKey)
                this.$refs.tree.setCurrentKey(defaultNode.id)
                this.listMemberUnderGroup(defaultNode.data.id)
              } else {
                this.$refs.tree.setCurrentKey(this.selectedNode.id)
                this.listMemberUnderGroup(this.selectedNode.id)
              }
              this.$message({ message: this.$t('opearteSuccess'), type: 'success' })
            } else {
              let error = this.$t('serverError')
              if (data.msg == '已添加，请查看其它分组') {
                error = this.$t('addrbook.return.addDevice.tips_1')
              }
              if (data.msg == '已被其它企业添加') {
                error = this.$t('addrbook.return.addDevice.tips_2')
              }
              if (data.msg == '该号码不存在') {
                error = this.$t('addrbook.return.addDevice.tips_3')
              }
              this.$message.error(error);
            }
          })
        } else {
          return false
        }
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    delDevice() {
      this.delDeviceDialogVisible = false
      const params = {
        // 传递数组的参数形式
        deleteMembersId: `${this.opearteDeviceIds}`
      }
      methodPost('api/infoPush/delete', params).then((data) => {
        if (data.status) {
          if (this.selectedNode != '') {
            this.listMemberUnderGroup(this.selectedNode.id)
          } else {
            const defaultNode = this.$refs.tree.getNode(this.defaultCheckedKey)
            this.listMemberUnderGroup(defaultNode.data.id)
          }
          this.$message({ message: this.$t('opearteSuccess'), type: 'success' })
        } else {
          this.$message.error(this.$t('serverError'));
        }
      })
    },
    startNow() {
      this.startNowDialogVisible = false
      const params = {
        // 传递数组的参数形式
        deleteMembersId: `${this.opearteDeviceIds}`
      }
      methodPost('api/infoPush/startNow', params).then((data) => {
        if (data.status) {
          this.$message({ message: this.$t('opearteSuccess'), type: 'success' })
        } else {
          this.$message.error(this.$t('serverError'));
        }
      })
    },
    stopNow() {
      this.stopNowDialogVisible = false

      const params = {
        // 传递数组的参数形式
        deleteMembersId: `${this.opearteDeviceIds}`
      }
      methodPost('api/infoPush/stopNow', params).then((data) => {
        if (data.status) {
          this.$message({ message: this.$t('opearteSuccess'), type: 'success' })
        } else {
          this.$message.error(this.$t('serverError'));
        }
      })
    },
    adjustDeviceGroupTreeNodeCilck(node) {
      this.adjustGroupId = node.id
    },
    adjustDeviceGroup() {
      this.adjustDeviceGroupDialogVisible = false
      const params = {
        // 传递数组的参数形式
        contactMembersId: `${this.opearteDeviceIds}`,
        adjustAtGroupId: this.adjustGroupId
      }
      // eslint-disable-next-line no-undef
      methodPost('api/infoPush/adjustGroup', params).then((data) => {
        if (data.status) {
          this.$refs.tree.setCurrentKey(this.adjustGroupId)
          this.listMemberUnderGroup(this.adjustGroupId)
          this.$message({ message: this.$t('opearteSuccess'), type: 'success' })
        } else {
          this.$message.error(this.$t('serverError'));
        }
      })
    },
    searchMember() {
      if (this.searchKeyword == '') {
        return
      }
      const params = {
        params: {
          searchKeyword: this.searchKeyword
        }
      }
      methodGet('/api/infoPush/listBook', params).then((data) => {
        if (data.status) {
          this.listBook = data.data
          this.computePage()
          this.$refs.tree.setCurrentKey(data.data[0].groupId)
        }
      })
    },
    openEditDeviceNameDialog(row) {
      this.editDeviceNameDialogVisible = true
      this.editDeviceForm.number = row.mzNumber
      this.editDeviceForm.id = row.id
    },
    closeEditDeviceNameDialog() {
      this.editDeviceNameDialogVisible = false
      this.editDeviceForm = {}
    },
    editDeviceName() {
      this.$refs['editDeviceForm'].validate((valid) => {
        if (valid) {
          this.editDeviceNameDialogVisible = false
          const params = {
            nickName: this.editDeviceForm.name,
            mzNumber: this.editDeviceForm.number,
            id: this.editDeviceForm.id
          }
          methodPost2('api/infoPush/modify', params).then((data) => {
            if (data.status) {
              this.$refs.tree.setCurrentKey(this.selectedNode.id)
              this.listMemberUnderGroup(this.selectedNode.id)
              this.$message({ message: this.$t('opearteSuccess'), type: 'success' })
            } else {
              this.$message.error(this.$t('serverError'));
            }
          })
        } else {
          return false
        }
      })
    },
    closeNoChildrenDialog() {
      this.noChildrenDialogVisible = false
      this.openAddGroupDialog(this.treeData[0])
    }
  }
}

